import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";

export default function Contactus() {

  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();

    // 🔁 auto refresh every 5 sec (optional)
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, []);

  const fetchData = () => {
   fetch(`${BASE_URL}/api/getJoin.php?t=${Date.now()}`)
      .then(res => res.json())
      .then(result => setData(result))
      .catch(err => console.error(err));
  };
 const deleteItem = (id) => {

  // 🔴 confirm before delete (optional but best)
  if (!window.confirm("Are you sure you want to delete?")) return;

 fetch(`${BASE_URL}/api/deleteJoin.php?id=${id}`)
    .then(res => res.json())
    .then(data => {
      alert(data.message);   // ✅ show alert
      fetchData();           // 🔄 refresh table
    })
    .catch(err => {
      console.error(err);
      alert("Something went wrong ❌");
    });
};

  return (
    <div className="table-card">

      <h2> સંપર્કો જુઓ</h2>

      <table className="join-table">
        <thead>
          <tr>
            <th>#</th>
            <th>નામ</th>
            <th>મોબાઇલ</th>
            <th>પ્રશ્ન</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td>{item.phone}</td>
                <td>{item.address}</td>
                <td>
  <button style={{
            background: "#b41212",
            color: "#fff",
            border: "none",
            padding: "5px 10px",
            cursor: "pointer"
          }} onClick={() => deleteItem(item.id)}>Delete</button>
</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">કોઈ અરજી નથી</td>
            </tr>
          )}

        </tbody>
      </table>

    </div>
  );
}